// Icon for a message banner. Each token has its own SVG in public/img, already stroked in the
// token colour (see scss/metrics/Alerts.scss); `.custom-message-icon img` normalises them to one
// size since the source files differ (30x26 / 32x32 / 29x29).

const ICONS = {
    'alert-danger': '/static/img/message-icon-danger.svg',
    'alert-warning': '/static/img/message-icon-warning.svg',
    'alert-success': '/static/img/message-icon-success.svg',
    'alert-info': '/static/img/message-icon-info.svg',
};

/** Icon for the given message type, falling back to the error icon like `message_type` does. */
export const MessageIcon = ({ type }) => (
    <span className="custom-message-icon">
        <img src={ICONS[type] ?? ICONS['alert-danger']} alt="" />
    </span>
);
